module.exports = __webpack_public_path__ + "img/d19bcd6.jpg";